/**
 * DesktopNav - Desktop navigation bar component
 */
import React from 'react';
import { Link } from 'react-router-dom';

export const DesktopNav = ({ navLinks }) => {
  // Using inline styles to prevent browser extension conflicts
  // Extensions often inject `display: none !important` on `.hidden` class
  const [isMdScreen, setIsMdScreen] = React.useState(window.innerWidth >= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMdScreen(window.innerWidth >= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navStyle = {
    display: isMdScreen ? 'flex' : 'none',
    alignItems: 'center',
    gap: window.innerWidth >= 1024 ? '2.5rem' : '1.5rem',
    flexWrap: 'nowrap'
  };

  return (
    <nav 
      id="desktop-nav"
      data-testid="desktop-nav"
      style={navStyle}
    >
      {navLinks && navLinks.length > 0 ? (
        navLinks.map((link) => (
          <Link
            key={link.href}
            to={link.href}
            className="font-body text-xs lg:text-sm uppercase tracking-wide hover:text-site-accent-blue transition-colors whitespace-nowrap"
            data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {link.label}
          </Link>
        ))
      ) : null}
    </nav>
  );
};

export default DesktopNav;
